import "../../../assets/css/TimeMachineController/timeMachineController.css";
import playButton from "../../../assets/icons/play.png";
import pauseButton from "../../../assets/icons/pauseIcon.png";
import forwardButton from "../../../assets/icons/forward15.png";
import backwardButton from "../../../assets/icons/backward15.png";
import downArrow from "../../../assets/icons/downArrow.png";
import upArrow from "../../../assets/icons/upArrow.png";
import { timeStampMinuteToHourFormatter } from "../../../util/helper/helperFunctions";
import { timeFromInt } from "time-number";
import { Slider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPageCount,
  setGroupDataCount,
  setGroupDataCurrentCount,
  setSeekPosition,
  setTimeMachineControllerIsOpen,
  setTimeMachineLoader,
  setTimeMachineState
} from "../../../store/oldTimeMachineSlice";

const TimeMachineController = () => {
  const dispatch = useDispatch();
  const {
    seekPosition: currentSeekPosition,
    totalSeekPosition,
    timeMachineControllerIsOpen,
    timeMachineState,
    timeMachineLoader
  } = useSelector((state) => state.oldTimeMachine);

  const seekBarChangeHandler = (e) => {
    dispatch(setTimeMachineLoader(true));
    dispatch(setSeekPosition(e));
    dispatch(setCurrentPageCount(e));

    dispatch(setGroupDataCurrentCount(0));

    dispatch(setGroupDataCount(0));
  };

  const playPauseTimeMachine = () => {
    dispatch(setTimeMachineState(!timeMachineState));

    dispatch(setGroupDataCurrentCount(0));

    dispatch(setGroupDataCount(0));
  };

  const backward15Seconds = () => {
    dispatch(setTimeMachineLoader(true));
    let backwarded15SecondsPosition = Number(currentSeekPosition) - 15;
    if (backwarded15SecondsPosition <= 0) {
      dispatch(setSeekPosition(1));

      dispatch(setCurrentPageCount(1));
    } else {
      dispatch(setSeekPosition(backwarded15SecondsPosition));

      dispatch(setCurrentPageCount(backwarded15SecondsPosition));

      dispatch(setGroupDataCurrentCount(0));

      dispatch(setGroupDataCount(0));
    }
  };

  const forwarded15Seconds = () => {
    dispatch(setTimeMachineLoader(true));
    let forwarded15SecondsPosition = Number(currentSeekPosition) + 15;
    if (forwarded15SecondsPosition >= totalSeekPosition) {
      dispatch(setSeekPosition(totalSeekPosition));

      dispatch(setCurrentPageCount(totalSeekPosition));
      dispatch(setTimeMachineState(false));
    } else {
      dispatch(setSeekPosition(forwarded15SecondsPosition));

      dispatch(setCurrentPageCount(forwarded15SecondsPosition));

      dispatch(setGroupDataCurrentCount(0));

      dispatch(setGroupDataCount(0));
    }
  };

  const getCurrentSeekPosition = () => {
    return currentSeekPosition - 1;
  };

  const getTotalSeekPosition = () => {
    return totalSeekPosition;
  };

  return (
    <>
      {timeMachineControllerIsOpen ? (
        <div className="time-machine-controller-container">
          <div className="time-machine-sections">
            <div className="time-machine-controller-top-section">
              <Slider
                className="time-machine-seek-bar"
                name="timeMachineSeekbar"
                id="timeMachineSeekbarId"
                min={0}
                max={totalSeekPosition}
                value={currentSeekPosition}
                onAfterChange={(e) => seekBarChangeHandler(e)}
                draggableTrack={true}
                controlSize={20}
                railSize={200}
                dotActiveBorderColor="#4461F2"
                dotBorderColor="#4461F2"
                handleActiveColor="#EEEEEE"
                handleColor="#EEEEEE"
                trackBg="#EEEEEE"
                trackHoverBg="#EEEEEE"
              />
            </div>
            <div className="time-machine-controller-bottom-section">
              <div className="time-bar-section">
                {timeStampMinuteToHourFormatter(
                  timeFromInt(currentSeekPosition)
                )}{" "}
                /{" "}
                {timeStampMinuteToHourFormatter(timeFromInt(totalSeekPosition))}
              </div>
              <div className="control-buttons-section">
                <img
                  onClick={() => backward15Seconds()}
                  className={`${
                    timeMachineLoader || getCurrentSeekPosition() == 0
                      ? "no-action-allowed"
                      : "time-machine-fast-forward-btn"
                  }`}
                  src={backwardButton}
                />
                {timeMachineState ? (
                  <img
                    src={pauseButton}
                    onClick={() => playPauseTimeMachine()}
                    className={`${
                      timeMachineLoader
                        ? "no-action-allowed"
                        : "time-machine-play-btn"
                    }`}
                  />
                ) : (
                  <img
                    onClick={() => playPauseTimeMachine()}
                    className={`${
                      timeMachineLoader
                        ? "no-action-allowed"
                        : "time-machine-play-btn"
                    }`}
                    src={playButton}
                  />
                )}
                <img
                  onClick={() => forwarded15Seconds()}
                  className={`${
                    timeMachineLoader ||
                    getCurrentSeekPosition() == getTotalSeekPosition()
                      ? "no-action-allowed"
                      : "time-machine-fast-forward-btn"
                  }`}
                  src={forwardButton}
                />
              </div>
              <div
                onClick={() =>
                  dispatch(
                    setTimeMachineControllerIsOpen(!timeMachineControllerIsOpen)
                  )
                }
                className="toggle-controller-section"
              >
                <h4>Hide Controls</h4>
                <img src={downArrow} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="small-controller-toggle-container">
          <div
            onClick={() =>
              dispatch(
                setTimeMachineControllerIsOpen(!timeMachineControllerIsOpen)
              )
            }
            className="small-controller-toggle-section"
          >
            <img src={upArrow} />
            <h4>Open Controls</h4>
          </div>
        </div>
      )}
    </>
  );
};

export default TimeMachineController;
